module.exports = __webpack_public_path__ + "static/media/st_anthonys_logo-removebg-preview-1.8f3be4c3.png";